import { render, staticRenderFns } from "./swapp.vue?vue&type=template&id=36ad3f52&"
import script from "./swapp.vue?vue&type=script&lang=js&"
export * from "./swapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports